<div class="progress-wrapper">
  <div class="progress-bar">
    <div class="progress-fill" [style.width.%]="progress"></div>
  </div>

  <div
    class="marker"
    [style.left.%]="progress"
    [style.background]="markerColor"
  ><div class="white-inner-circle"></div>
</div>
